import React, {useState, forwardRef, useRef} from 'react';
import Marquee from 'react-fast-marquee';
import About from './About';
import ReviewCard from './ReviewCard';
import BottomToTop from './BottomToTop';
import Corousel from './Corousel';
import WorkCard from './workCard';
import "./HomePage.css";
import ContactForm from './ContactForm';



const yellowInitial = { backgroundColor: "#FFC800", color: "#000000", borderRadius: "10px" };
const yellowMid = {backgroundColor: "#FFC800" ,color: "#ffffff", borderRadius: "10px"};
const yellowFinal = {backgroundColor: "#000000" ,color: "#ffffff", borderColor: "#FFC800", borderRadius: "10px"};
const transparentInitial = { backgroundColor: "transparent", color: "#ffffff", borderColor: "#ffffff", borderRadius: "10px" };
//const transparentMid = { backgroundColor: "transparent", color: "#000000", borderColor: "#ffffff", borderRadius: "7px" };
const transparentFinal = { backgroundColor: "#FFC800", color: "#000000", borderColor: "#ffffff", borderRadius: "10px" };
//const greenInitial = { backgroundColor: "#008000", color: "#000000", borderColor: "#ffffff", borderRadius: "7px" };
const greenMid = { backgroundColor: "#008000", color: "#ffffff", borderColor: "#008000", borderRadius: "10px" };
//const greenFinal = { backgroundColor: "#000000", color: "#ffffff", borderColor: "#008000", borderRadius: "7px" };
//const bgColorFirstInitial = {color:"#ffffff", backgroundColor:"transparent", height:"50px", width:"165px", padding:"0", borderColor:"#626262"};
//const bgColorFirstFinal = {color:"#FFDD96", backgroundColor:"#000000", height:"50px", width:"165px", padding:"0", borderColor:"#FDBA2F"};
//const bgColorSecondInitial = {color:"#ffffff", backgroundColor:"transparent", height:"50px", width:"165px",  padding:"0", borderColor:"#626262"};
//const bgColorSecondFinal = {color:"#FFDD96", backgroundColor:"#000000", height:"50px", width:"165px", padding:"0", borderColor:"#FDBA2F"};
//const bgColorThirdInitial = {color:"#ffffff", backgroundColor:"transparent", height:"50px", width:"165px", padding:"0", borderColor:"#626262"};
//const bgColorThirdFinal = {color:"#FFDD96", backgroundColor:"#000000", height:"50px", width:"165px", padding:"0", borderColor:"#FDBA2F"};
//const bgColorFourthInitial = {color:"#ffffff", backgroundColor:"transparent", height:"50px", width:"165px", padding:"0", borderColor:"#626262"};
//const bgColorFourthFinal = {color:"#FFDD96", backgroundColor:"#000000", height:"50px", width:"165px", padding:"0", borderColor:"#FDBA2F"};

const HomePage = forwardRef((props, ref) => {

  const callNowHomeRef = useRef(null);
  const callNowHomeRippleRef = useRef(null);
  
  const callNowHomeHandleClick = (event) => {
    const callNowHome = callNowHomeRef.current;
    const callNowHomeRipple = callNowHomeRippleRef.current;
    const callNowHomeRect = callNowHome.getBoundingClientRect();
    const {left, top} = callNowHomeRect;
    const callNowHomeLeftPosition = event.clientX - left;
    const callNowHomeTopPosition = event.clientY - top;
    callNowHomeRipple.style.left = callNowHomeLeftPosition + "px";
    callNowHomeRipple.style.top = callNowHomeTopPosition + "px";
    callNowHomeRipple.classList.add("callNowHomeActive");
    setTimeout(() => {
      callNowHomeRipple.classList.remove("callNowHomeActive");
    },1000);
    setColor(yellowMid);
    setTimeout(() => {
      setColor(yellowFinal);
    },600);
  }
  
  const callNowHomeHandleClickRemove = () => {
    const callNowHomeRipple = callNowHomeRippleRef.current;
    setColor(yellowInitial);
    callNowHomeRipple.classList.remove("callNowHomeActive");
  }
  
  const callNowHomeClick = () => {
    setColor(yellowMid);
    setTimeout(() => {
      setColor(yellowInitial);
    },600);
  }

  const callNowHomeClickRemove = () => {
    setColor(yellowInitial);
  }


  const whatsappHomeRef = useRef(null);
  const whatsappHomeRippleRef = useRef(null);

  const whatsappHomeHandleClick = (event) => {
    const whatsappHome = whatsappHomeRef.current;
    const whatsappHomeRipple = whatsappHomeRippleRef.current;
    const whatsappHomeRect = whatsappHome.getBoundingClientRect();
    const {left, top} = whatsappHomeRect;
    const whatsappHomeLeftPosition = event.clientX - left;
    const whatsappHomeTopPosition = event.clientY - top;
    whatsappHomeRipple.style.left = whatsappHomeLeftPosition + "px";
    whatsappHomeRipple.style.top = whatsappHomeTopPosition + "px";
    whatsappHomeRipple.classList.add("whatsappHomeActive");
    setTimeout(() => {
      whatsappHomeRipple.classList.remove("whatsappHomeActive");
    },1000);
    setColorr(greenMid);
    setTimeout(() => {
      setColorr(transparentInitial);
    },600);
  }

  const whatsappHomeHandleClickRemove = () => {
    const whatsappHomeRipple = whatsappHomeRippleRef.current;
    setColorr(transparentInitial);
    whatsappHomeRipple.classList.remove("whatsappHomeActive");
  }

  const whatsappHomeClick = () => {
    setColorr(greenMid);
    setTimeout(() => {
      setColorr(transparentInitial);
    },600);
    
  }

  const whatsappHomeClickRemove = () => {
    setColorr(transparentInitial);
  }

  const letsWorkTogetherRef = useRef(null);
  const letsWorkTogetherRippleRef = useRef(null);

  const letsWorkTogetherHandleClick = (event) => {
    const letsWorkTogether = letsWorkTogetherRef.current;
    const letsWorkTogetherRipple = letsWorkTogetherRippleRef.current;
    const letsWorkTogetherRect = letsWorkTogether.getBoundingClientRect();
    const {left, top} = letsWorkTogetherRect;
    const letsWorkTogetherLeftPosition = event.clientX - left;
    const letsWorkTogetherTopPosition = event.clientY - top;
    letsWorkTogetherRipple.style.left = letsWorkTogetherLeftPosition + "px";
    letsWorkTogetherRipple.style.top = letsWorkTogetherTopPosition + "px";
    letsWorkTogetherRipple.classList.add("letsWorkTogetherActive");
    setTimeout(() => {
      letsWorkTogetherRipple.classList.remove("letsWorkTogetherActive");
    },1000);
    setColour(transparentInitial);
    setTimeout(() => {
      setColour(transparentFinal);
    },600);
  }

  const letsWorkTogetherHandleClickRemove = () => {
    const letsWorkTogetherRipple = letsWorkTogetherRippleRef.current;
    setColour(transparentInitial);
    letsWorkTogetherRipple.classList.remove("letsWorkTogetherActive");
  }

  const connectNowRef = useRef(null);
  const connectNowRippleRef = useRef(null);
  
  const connectNowHandleClick = (event) => {
    const connectNow = connectNowRef.current;
    const connectNowRipple = connectNowRippleRef.current;
    const connectNowRect = connectNow.getBoundingClientRect();
    const {left, top} = connectNowRect;
    const connectNowLeftPosition = event.clientX - left;
    const connectNowTopPosition = event.clientY - top;
    connectNowRipple.style.left = connectNowLeftPosition + "px";
    connectNowRipple.style.top = connectNowTopPosition + "px";
    connectNowRipple.classList.add("connectNowActive");
    setTimeout(() => {
      connectNowRipple.classList.remove("connectNowActive");
    },1000);
    setColor(yellowMid);
    setTimeout(() => {
      setColor(yellowFinal);
    },600);
  }
  
  const connectNowHandleClickRemove = () => {
    const connectNowRipple = connectNowRippleRef.current;
    setColor(yellowInitial);
    connectNowRipple.classList.remove("connectNowActive");
  }
  


  const joinUsRef = useRef(null);
  const joinUsRippleRef = useRef(null);

  const joinUsHandleClick = (event) => {
    const joinUs = joinUsRef.current;
    const joinUsRipple = joinUsRippleRef.current;
    const joinUsRect = joinUs.getBoundingClientRect();
    const {left, top} = joinUsRect;
    const joinUsLeftPosition = event.clientX - left;
    const joinUsTopPosition = event.clientY - top;
    joinUsRipple.style.left = joinUsLeftPosition + "px";
    joinUsRipple.style.top = joinUsTopPosition + "px";
    joinUsRipple.classList.add("joinUsActive");
    setTimeout(() => {
      joinUsRipple.classList.remove("joinUsActive");
    },1000);
    setColor(yellowMid);
    setTimeout(() => {
      setColor(yellowInitial);
    },600);
  }

  const joinUsHandleClickRemove = () => {
    const joinUsRipple = joinUsRippleRef.current;
    setColor(yellowInitial);
    joinUsRipple.classList.remove("joinUsActive");
  }

  const handleButtonClick = () => {
    const phoneNumber = '7827111656'; // Replace with the actual phone number
    const message = 'Hello! I would like to drop a DM.'; // Optional: Predefined message
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');  
  };

  const handleCallClick = () => {
    const phoneNumber = '7827111656'; // Replace with the actual phone number
    const url = `tel:${phoneNumber}`;
    window.location.href = url; // Initiate the call
  };

  const dropUsADmRef = useRef(null);
  const dropUsADmRippleRef = useRef(null);

  const dropUsADmHandleClick = (event) => {
    const dropUsADm = dropUsADmRef.current;
    const dropUsADmRipple = dropUsADmRippleRef.current;
    const dropUsADmRect = dropUsADm.getBoundingClientRect();
    const {left, top} = dropUsADmRect;
    const dropUsADmLeftPosition = event.clientX - left;
    const dropUsADmTopPosition = event.clientY - top;
    dropUsADmRipple.style.left = dropUsADmLeftPosition + "px";
    dropUsADmRipple.style.top = dropUsADmTopPosition + "px";
    dropUsADmRipple.classList.add("dropUsADmActive");
    setTimeout(() => {
      dropUsADmRipple.classList.remove("dropUsADmActive");
    },1000);
    setColour(transparentInitial);
    setTimeout(() => {
      setColour(transparentFinal);
    },600);
  }

  const dropUsADmHandleClickRemove = () => {
    const dropUsADmRipple = dropUsADmRippleRef.current;
    setColour(transparentInitial);
    dropUsADmRipple.classList.remove("dropUsADmActive");
  }

  const aboutSectionRef = useRef();

  const aboutScrollHandler = (elmRef) => {
    window.scrollTo({top: elmRef.current.offsetTop, behavior:"smooth"});
  };

  const [color, setColor] =useState(yellowInitial)
  const [colorr, setColorr] =useState(transparentInitial)
  const [colour, setColour] =useState(transparentInitial)
  
  return (
    <>
      <div style={{width:"justify"}}>

        <div className="page1 gradient1" style={{width:"100%"}}>
          <div className="container hideContainer" style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <div className="hide" style={{backgroundColor:"#ffffff", color:"#000000", borderRadius:"7px"}}>
              <img className="hideImg" src="plus.jpg" alt="plusstar"/>
              <span className="hideSpan">We help brands go viral on the internet</span>
            </div>
          </div>

          <div className=" page1mainheadingContainer" style={{backgroundColor:"transparent", color:"#ffffff", display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
              <h1 className="page1mainheading">The Ultimate Social Media Growth Engine for Fast-Growing Startups</h1>
          </div>

          <div className=" page1subheadingContainer" style={{backgroundColor:"transparent", color:"#ffffff", display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
            <p className="page1subheading">Next-Gen Content Marketing Agency<br></br>Empowering Brands Worldwide</p>
          </div>


          {/*For screen sizes above 991px*/}
          <div className="container page1buttons">
            <button className="btn button1 callNowHome" ref={callNowHomeRef} type="button" onMouseEnter={callNowHomeHandleClick} onMouseLeave={callNowHomeHandleClickRemove}       onClick={handleCallClick} // Add onClick handler here
 style={color}>
              <strong><h5 className="button1h5" style={{marginTop:"0.2rem"}}>Call Now</h5></strong>
              <span ref={callNowHomeRippleRef} className="callNowHomeRippleEffect"></span>
            </button>

            <button className="btn button1 whatsappHome" ref={whatsappHomeRef} type="button" onMouseEnter={whatsappHomeHandleClick} onMouseLeave={whatsappHomeHandleClickRemove}       onClick={handleButtonClick} // Add onClick handler here
 style={colorr}>
              <strong><h5 className="button1h5" style={{marginTop:"0.2rem"}}>Whatsapp</h5></strong>
              <span ref={whatsappHomeRippleRef} className="whatsappHomeRippleEffect"></span>
            </button>
          </div>


          {/*For screen sizes below 992px*/}
          <div className="container page1buttonsSmall">
            <button className="btn button1" type="button" onMouseEnter={callNowHomeClick} onMouseLeave={callNowHomeClickRemove} onClick={handleCallClick} // Add onClick handler here
            style={color}>
              <strong><h5 className="button1h5" style={{marginTop:"0.3rem"}}>Call Now</h5></strong>
            </button>

            <button className="btn button1" type="button" onMouseEnter={whatsappHomeClick} onMouseLeave={whatsappHomeClickRemove} onClick={handleButtonClick} // Add onClick handler here 
            style={colorr}>
              <strong><h5 className="button1h5" style={{marginTop:"0.3rem"}}>Whatsapp</h5></strong>
            </button>
          </div>

          <div style={{marginTop:"0px", paddingBottom:"70px"}}>
            <Marquee pauseOnHover={false} play={true}>
              <Corousel source="markt.jpeg" heading="Marketing Stories" subHeading="850K Followers"/>
              <Corousel source="startupnews.jpeg" heading="Startupnews FYI" subHeading="400K Followers"/>
              <Corousel source="metav.jpeg" heading="Creators of Aiverse" subHeading="20K Followers"/>
              <Corousel source="visibleCampus.jpeg" heading="Visible Campus" subHeading="10K Followers"/>
              <Corousel source="blackSwan.jpeg" heading="Blackswan" subHeading="17K Followers"/>
              <Corousel source="indFounders.jpeg" heading="IND Founders" subHeading="90K Followers"/>
              <Corousel source="factsAndStuffByD.jpeg" heading="Facts and Stuff by D" subHeading="200K Followers"/>
            </Marquee>
          </div>
  
      </div>



      <div className="page2" ref={ref} style={{backgroundColor:"transparent", width:"100%"}}>

        <div className="container page2headingcontainer" ref={aboutSectionRef} style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
          <div className="container my-2" style={{backgroundColor:"transparent", color:"#ffffff", display:"block"}}>
            <p><h1 className="page2heading" style={{color:"#000000"}}>What’s hyperContent All About?</h1></p>
            <p><h3 className="page2subheading" style={{color:"#2a2a2a"}}>Fueling brands' organic growth</h3></p>
          </div>
        </div>

        <div className="page2ContentDiv">
          <div className="page2Content1">
            <img src="aboutImg1.png" alt="aboutImage" className="page2Content1Img"></img>
          </div>

          <div className="page2Content2">
            <div className="page2Content2Div">
              <p className="page2Content2Intro" style={{fontSize: "1.15rem", color: "#000000", fontWeight: "400"}}><span style={{fontSize: "1.15rem", color: "#000000", fontWeight: "600"}}>HyperContent </span>is a content marketing agency dedicated to crafting compelling narratives that captivate audiences online. We offer tailored <span style={{fontSize: "1.15rem", color: "#000000", fontWeight: "600"}}>content & growth strategies, and post-production services </span>to ensure your message reaches your target audience effectively.</p>

              <h2 className="page2Content2Point1" style={{fontSize: "1.4rem", color: "#000000", fontWeight: "600"}}>Services We Offer</h2>
              <ul style={{fontSize: "1.1rem", color: "#000000", listStyleType:"disc"}}>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>Social Media Management</p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>Pre- & post-production service (Copywriting, Graphic design & Video Editing)</p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>Personal Branding</p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>Distribution on Big and small pages / channels</p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>Social Media Growth Consultation</p></li>
              </ul>

              <h2 className="page2Content2Point2" style={{fontSize: "1.4rem", color: "#000000", fontWeight: "600"}}>Why Us?</h2>
              <ul style={{fontSize: "1.1rem", color: "#000000", listStyleType:"disc"}}>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>We have given our clients over <span style={{fontSize: "1.1rem", color: "#000000", fontWeight: "600"}}>100 million+ aggregate reach in 2024</span>.</p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>Our team understands social media better than anyone and has grown pages from scratch to <span style={{fontSize: "1.1rem", color: "#000000", fontWeight: "600"}}>700,000+ followers</span>.</p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>With us, experience hassle-free social media management, from ideation to execution.</p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>We have mastered viral growth techniques.</p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>Expertise in Niche-oriented branding strategies.</p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>We provide the best quality service at a more competitive price than our competitors.</p></li>
              </ul>

              <h2 className="page2Content2Point3" style={{fontSize: "1.4rem", color: "#000000", fontWeight: "600"}}>Our Partnerships</h2>
              <ul style={{fontSize: "1.1rem", color: "#000000", listStyleType:"disc"}}>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>We have Collaborated with <span style={{fontSize: "1.1rem", color: "#000000", fontWeight: "600"}}>200+ Instagram community pages </span>of different niches, with a reach of more than <span style={{fontSize: "1.1rem", color: "#000000", fontWeight: "600"}}>50 Million!</span></p></li>
                <li><p style={{fontSize: "1.1rem", color: "#000000", fontWeight: "400"}}>Partnered with <span style={{fontSize: "1.1rem", color: "#000000", fontWeight: "600"}}>100+ Creators </span>with a wide audience following range.</p></li>
              </ul>
            </div>

          </div>
        </div>


        <div>
          
          <About colour="#1F1F1F" logoUrl="logo.png" heading="Amplifying your brand with engaging content" 
            
           firstIcon="about1.png" firstFeature="Guaranteed boost in reach and engagement" secondIcon="about2.png" secondFeature="Acceleratig growth and sales with impactful content" thirdIcon="about3.png" thirdFeature="Strenthening brand connection with your target audience" aboutImage="aboutImg2.png"/>
        </div>

       

      </div>


      <div className="page3 gradient6" style={{display:"flex", justifyContent:"center", alignItems:"center", width:"100%"}}>
        <div className="page3Container" style={{backgroundColor:"#2E3233", borderRadius:"1.5rem"}}>
        <div className="container" style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
          <div className="page3SubHeading1" style={{backgroundColor:"transparent", borderRadius:"0.35rem"}}>
            <span className="page3SubHeading1Span1" style={{color:"#888586"}}>Trusted by</span>
            <span className="page3SubHeading1Span2" style={{color:"#ffffff"}}>30+ brands</span>
          </div>
        </div>

          <div className="container" style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
            <div className="container page3HeadingContainer" style={{backgroundColor:"transparent", color:"#ffffff", display:"block"}}>
              <p><h1 className="page3Heading">HyperContent Understands The Importance Of Branding & Digital Marketing in this new age economy</h1></p>
            </div>
          </div>

          <div className="container" style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
            <div className="container" style={{backgroundColor:"transparent", display:"block"}}>
              <p><h3 className="page3SubHeading2span1" style={{color:"#888586"}}>We help your brand outshine your competitors</h3></p>
              <p><h3 className="page3SubHeading2span2" style={{color:"#ffffff"}}>in 90 Days!</h3></p>
            </div>
          </div>



          <div className="container page3Features">

            <div className="container page3fFeature1" style={{display:"flex", alignItems:"center"}}>
              <div className="page3fFeature" style={{borderRadius:"5px", display:"flex", alignItems:"center", justifyContent:"center"}}>
                <img src="plus.jpg" alt="page3fFeature" className="page3fFeatureimg" style={{marginLeft:"2px"}}></img>
                <span className="page3fFeaturespan" style={{color:"white", display:"flex", alignItems:"start", justifyContent:"center"}}>Work with a team of skilled creative experts</span>
              </div>
            </div>

            <div className="container page3fFeature2" style={{display:"flex", alignItems:"center"}}>
              <div className="page3fFeature" style={{borderRadius:"5px", display:"flex", alignItems:"center", justifyContent:"center"}}>
                <img src="plus.jpg" alt="page3fFeature" className="page3fFeatureimg" style={{marginLeft:"2px"}}></img>
                <span className="page3fFeaturespan" style={{color:"white", display:"flex", alignItems:"start", justifyContent:"center"}}>Amplify your social presence</span>
              </div>
            </div>

            <div className="container page3fFeature3" style={{display:"flex", alignItems:"center"}}>
              <div className="page3fFeature" style={{borderRadius:"5px", display:"flex", alignItems:"center", justifyContent:"center"}}>
                <img src="plus.jpg" alt="page3fFeature" className="page3fFeatureimg" style={{marginLeft:"2px"}}></img>
                <span className="page3fFeaturespan" style={{color:"white", display:"flex", alignItems:"start", justifyContent:"center"}}>Save yourself the hassle by outsourcing your digital marketing to us</span>
              </div>
            </div>
          </div>



          <div className="container" style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
            <div className="container page3ButtonContainer" style={{backgroundColor:"transparent"}}>

              <button className="btn btn-lg page3Button letsWorkTogether" ref={letsWorkTogetherRef} type="button" onMouseEnter={letsWorkTogetherHandleClick} onMouseLeave={letsWorkTogetherHandleClickRemove} onClick={handleButtonClick} // Add onClick handler here 
              style={colour}>
                <h5 className="page3ButtonText" style={{marginTop:"0.3rem"}}><strong>Lets work together</strong></h5>
                <span ref={letsWorkTogetherRippleRef} className="letsWorkTogetherRippleEffect"></span>
              </button>

            </div>
          </div>


          <div className="corousel2Container">
            <Marquee pauseOnHover={true} play={true} speed={40}>
              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Marketing Stories</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Ind Founders</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Atomscoolya</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Bioscoolya</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Startupnews FYI</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Creators of Metaverse</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Blackswan</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Business Setup</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Soqal</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Visible Campus</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Eduinx</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">The Best Days</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Fortran</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Marketing Spots</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">The Business Blueprint</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Daily Dubai Updates</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Sadhguru Global School</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Better Place Addiwise</h3>
              </div>

              <div className="corousel2ImgContainer">
                <h3 className="brandNames">Thrift Vault</h3>
              </div>

            
            </Marquee>
          </div>  




          <div style={{marginTop:"25px", paddingBottom:"70px"}}>
            <Marquee pauseOnHover={true} play={true} speed={60}>

              <ReviewCard review='" Working with Hypercontent has been a game-changer for us. They didn’t just help us grow our social media, they helped us truly connect with our audience. Their strategies are smart, innovative, and designed to get results. If you’re a startup looking to scale fast, they’re the team you need."' name="- StartupNews.fyi"/>

              <ReviewCard review='" Hypercontent completely transformed the way we approach content marketing. They’re not just an agency – they’re a partner who understands the challenges of a growing startup. Thanks to their expertise, our brand visibility has skyrocketed, and our engagement is at an all-time high."' name="- Black Swan"/>

              <ReviewCard review='" As a niche brand, we struggled to find our voice on social media – until we partnered with Hypercontent. They crafted campaigns that truly resonated with our audience, driving real growth. The results speak for themselves. We couldn’t have asked for a better team!"' name="- BioScoolya"/>

              <ReviewCard review='" Hypercontent felt like an extension of our own team. Their dedication, creativity, and deep understanding of growth marketing were exactly what we needed. They helped us stand out in a crowded space and connect with our audience in a meaningful way."' name="- IND Founders"/>

              <ReviewCard review='" When we started working with Hypercontent, we knew we wanted to grow, but we didn’t realize how quickly they could make it happen. They’re more than a content marketing agency – they’re growth partners who think outside the box and deliver exceptional results."' name="- Creators of Metaverse"/>

            </Marquee>
          </div>
        </div>


      </div>



      {/*For screen sizes above 991 px*/}
      <div className="page4" style={{backgroundColor:"transparent", width:"100%"}}>
        <div className="page4Container" style={{display:"flex", justifyContemt:"center", alignItems:"center"}}>
          <div className="page4Container1Div" style={{backgroundColor:"transparent"}}>
            <p><h1 className="page4Container1Heading">Our Work Flow</h1></p>
            <p><h5 className="page4Container1SubHeading">We follow an efficient workflow for every brand.</h5></p>
          </div>

          <div classname="container page4Container1Button">
            <button className="btn btn-lg joinUs" ref={connectNowRef} type="button" onMouseEnter={connectNowHandleClick} onMouseLeave={connectNowHandleClickRemove} onClick={handleCallClick} // Add onClick handler here 
            style={color}>
              Connect Now
              <span ref={connectNowRippleRef} className="connectNowRippleEffect"></span>
            </button>
          </div>

          <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <div className="row my-5" style={{width:"100%", display:"flex"}}>

              <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{display:"flex", justifyContent:"center"}}>
                <WorkCard             source="ourWorkflowImg1.png" heading="Client Onboarding & Research" subHeading="We kick off by understanding your brand, goals, and audience thorough research and discovery sessions."/>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{display:"flex", justifyContent:"center"}}>
                <WorkCard             source="ourWorkflowImg2.png" heading="Content Strategy" subHeading="Next, we craft a tailored content plan that aligns with your objectives and sets a clear direction for success."/>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{display:"flex", justifyContent:"center"}}>
                <WorkCard             source="ourWorkflowImg3.png" heading="Content Creation" subHeading="We produce high-quality content and test different approaches to see what resonates best with your audience."/>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{display:"flex", justifyContent:"center"}}>
                <WorkCard             source="ourWorkflowImg4.png" heading="Doubling Down on Success" subHeading="We analyze performance and focus on scaling the strategies and content that deliver the best results."/>
              </div>
           </div>
          </div>


          
          


        </div>
      </div>


      {/*For screen sizes below 992 px*/}
      <div className="page5" style={{width:"100%"}}>
        <div className="page5Container" style={{display:"flex", justifyContemt:"center", alignItems:"center"}}>
          <div className="page5Container1">
            <div><h1 className="page5Container1Heading">Our Work Flow</h1></div>
            <div><h5 className="page5Container1SubHeading">We follow an efficient workflow for every brand.</h5></div>
          </div>

          <div classname="container page4Container1Button">
            <button className="btn btn-lg joinUs" ref={joinUsRef} type="button" onMouseEnter={joinUsHandleClick} onMouseLeave={joinUsHandleClickRemove} onClick={handleCallClick} // Add onClick handler here 
            style={color}>
              <span className="connectNowBtnText">Connect Now</span>
              <span ref={joinUsRippleRef} className="joinUsRippleEffect"></span>
            </button>
          </div>

          <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <div className="row my-5" style={{width:"100%", display:"flex"}}>
              
              <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{display:"flex", justifyContent:"center"}}>
                <WorkCard             source="ourWorkflowImg1.png" heading="Client Onboarding & Research" subHeading="We kick off by understanding your brand, goals, and audience through thorough research and discovery sessions."/>
              </div>
                
              <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{display:"flex", justifyContent:"center"}}>
                <WorkCard             source="ourWorkflowImg2.png" heading="Content Strategy" subHeading="Next, we craft a tailored content plan that aligns with your objectives and sets a clear direction for success."/>
              </div>
              
              <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{display:"flex", justifyContent:"center"}}>
                <WorkCard             source="ourWorkflowImg3.png" heading="Content Creation" subHeading="We produce high-quality content and test different approaches to see what resonates best with your audience."/>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{display:"flex", justifyContent:"center"}}>
                <WorkCard             source="ourWorkflowImg4.png" heading="Doubling Down on Success" subHeading="We analyze performance and focus on scaling the strategies and content that deliver the best results."/>
              </div>
           </div>
          </div>
        </div>

      </div>

      <BottomToTop/>




      <div className="page6 gradient7" style={{width:"100%"}}>

        <div style={{backgroundColor:"transparent", width:"100%"}}>

          {/*For screen sizes above 991 px*/}
          <div className="container page6TopContainerDiv1BigScreen" style={{justifyContent:"center", alignItems:"center", textAlign:"center"}}>
            <div className="container page6HeadingContainer" style={{color:"#ffffff"}}>
              <p><h1 className="page6Heading"><span className="page6HeadingSpan1" style={{color:"white",letterSpacing:"-2"}}>Ready to unleash the power of</span><span className="page6HeadingSpan2" style={{color:"#FFC800"}}>viral content?</span></h1></p>
            </div>
          </div>

          {/*For screen sizes below 991 px*/}
          <div className="container page6TopContainerDiv1SmallScreen" style={{justifyContent:"center", alignItems:"center", textAlign:"center"}}>
            <div className="container page6HeadingContainer" style={{color:"#ffffff"}}>
              <p><h1 className="page6Heading"><span className="page6HeadingSpan1" style={{color:"white", }}>Ready to unleash the power of</span><span className="page6HeadingSpan2" style={{color:"#FFC800"}}> viral content?</span></h1></p>
            </div>
          </div>

          <div className="container page6TopContainerDiv2" style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
            <div className="container page6ButtonContainer" style={{backgroundColor:"transparent"}}>
              
              <button className="btn page6Button dropUsADm" ref={dropUsADmRef} type="button" onMouseEnter={dropUsADmHandleClick} onMouseLeave={dropUsADmHandleClickRemove}  onClick={handleButtonClick} // Add onClick handler here  
              style={colour}>
                <h5 className="page6ButtonText"><strong>Drop us a DM now</strong></h5>
                <span ref={dropUsADmRippleRef} className="dropUsADmRippleEffect"></span>
              </button>

            </div>
          </div>

        </div>


        <div className="page6BottomContainer" style={{backgroundColor:"#3D099D", display:"flex"}}>
          
          <div className="page6BottomContainerDiv">

            <div className="page6BottomLogoContainer" style={{display:"flex"}}>
              <img className="page6BottomLogo" style={{height:"2rem", width:"11rem"}} src="logo.png" alt="logo"></img>
            </div>

            {/*For screen sizes above 991px */}
            <div className="page6BottomDetails1Big" style={{color:"#ffffff", display:"flex", alignItems:"center"}}>
              <div className="page6BottomDetailsImgContainerBig">
                <i className="fa-solid fa-location-dot page6BottomDetails1ImgBig" style={{alignSelf:"center", cursor:"pointer"}}></i>
              </div>
              <div className="page6BottomDetails1ContentContainerBig">
                <h3 className="page6BottomDetailsContent1Big" style={{cursor:"pointer"}}>WORKWORM, B-13, DLF IND. AREA, NEAR NHPC METRO STATION, FARIDABAD - 121003</h3>
              </div> 
            </div>

            {/*For screen sizes below 991px */}
            <div className="page6BottomDetails1Small" style={{color:"#ffffff", display:"flex", alignItems:"center"}}>
              <div className="page6BottomDetailsImgContainerSmall">
                <i className="fa-solid fa-location-dot page6BottomDetails1ImgSmall" style={{alignSelf:"center", cursor:"pointer"}}></i>
              </div>
              <div className="page6BottomDetails1ContentContainerSmall">
                <h3 className="page6BottomDetailsContent1Small" style={{cursor:"pointer"}}>WORKWORM, B-13, DLF IND. AREA, <br></br>NEAR NHPC METRO STATION, <br></br>FARIDABAD - 121003</h3>
              </div> 
            </div>

            <div className="page6BottomDetails2" style={{color:"#ffffff", display:"flex", alignItems:"center"}}>
              <div>
                <i className="fa-solid fa-envelope page6BottomDetailsImg" style={{alignSelf:"center", cursor:"pointer"}}></i>
              </div>
              <div>
                <h3 className="page6BottomDetailsContent" style={{cursor:"pointer"}}>Shubham@hypercontent.xyz</h3>
              </div> 
            </div>

            <div className="page6BottomDetails3" style={{color:"#ffffff", display:"flex", alignItems:"center"}}>
              <div>
                <i className="fa-solid fa-phone page6BottomDetailsImg" style={{alignSelf:"center", cursor:"pointer"}}></i>
              </div>
              <div>
                <h3 className="page6BottomDetailsContent" style={{cursor:"pointer"}}>+91 7827111656</h3>
              </div> 
            </div>

            <div className="page6BottomIconsContainer" style={{color:"#ffffff", display:"flex", alignItems:"center"}}>
              <div className = "page6BottomIconContainer" style={{alignSelf:"center"}} onClick={()=>{    const url = "https://www.linkedin.com/company/hypercontentagency/posts/?feedView=all"; // Replace with your desired URL
    window.open(url, '_blank'); // Opens the URL in a new tab
}}>
                <i className="fa-brands fa-linkedin page6BottomIcon" style={{alignSelf:"center", cursor:"pointer"}}></i>
              </div>
            </div>

            

            


            {/*For screen sizes above 479 px*/}
            <div className="page6BottomButtonsBigScreen">
              <div className="page6BottomButtonsBigScreenRow1" style={{color:"#ffffff"}}>
                <button className="btn page6BottomButtonsBigScreenButton1" onClick={()=> aboutScrollHandler(aboutSectionRef)} type="button" style={{color:"#ffffff", backgroundColor:"transparent", padding:"0", marginLeft:"0"}}><h3 className="page6BottomButtonsBigScreenButtonText">About Us</h3></button>
                <button className="btn page6BottomButtonsBigScreenButton2" type="button" style={{color:"#ffffff", backgroundColor:"transparent", padding:"0"}}><h3 className="page6BottomButtonsBigScreenButtonText">Terms & Conditions</h3></button>
                <button className="btn page6BottomButtonsBigScreenButton3" type="button" style={{color:"#ffffff", backgroundColor:"transparent", padding:"0"}}><h3 className="page6BottomButtonsBigScreenButtonText">Privacy Policy</h3></button>
              </div>
            </div>


            {/*For screen sizes below 480 px*/}
            <div className="page6BottomButtonsSmallScreen">
              <div className="page6BottomButtonsSmallScreenRow1" style={{color:"#ffffff", display:"flex", justifyContent:"space-around", alignItems:"center", textAlign:"center"}}>
                <button className="btn page6BottomButtonsSmallScreenButton" onClick={()=> aboutScrollHandler(aboutSectionRef)} type="button" style={{color:"#ffffff", backgroundColor:"transparent", padding:"0",textAlign:"center"}}><h3 className="page6BottomButtonsSmallScreenButtonText">About Us</h3></button>
              </div>

              <div className="page6BottomButtonsSmallScreenRow2" style={{color:"#ffffff", display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
                <button className="btn page6BottomButtonsSmallScreenButton" type="button" style={{color:"#ffffff", backgroundColor:"transparent", margin:"0", padding:"0",textAlign:"center"}}><h3 className="page6BottomButtonsSmallScreenButtonText">Terms & Conditions</h3></button>
              </div>

              <div className="page6BottomButtonsSmallScreenRow3" style={{color:"#ffffff", display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
                <button className="btn page6BottomButtonsSmallScreenButton" type="button" style={{color:"#ffffff", backgroundColor:"transparent", margin:"0", padding:"0",textAlign:"center"}}><h3 className="page6BottomButtonsSmallScreenButtonText">Privacy Policy</h3></button>
              </div>

            </div>

            <div className="page6BottomCopyrightDiv" style={{color:"#ffffff"}}>
              <h3 className="page6BottomCopyright">Copyright ©  2024 All Rights Reserved</h3>
            </div>


          </div>
          <div className="contactFormContainer">
            <ContactForm />
          </div>

        </div>

      </div>

    </div>
    </>
  )
}); 

export default HomePage;